export default __webpack_public_path__ + "static/media/a011-startup-01.288d9e3c.svg";